/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * External dependencies
 */
import { createSolidFromString } from '@web-stories-wp/patterns';
/**
 * Internal dependencies
 */
import {
  SHARED_DEFAULT_ATTRIBUTES,
  SHARED_DEFAULT_CLEARABLE_ATTRIBUTES,
} from '../shared/constants';
import PanelTypes from '../../components/panels/design/types';

const defaultBackgroundColor = createSolidFromString('#c4c4c4');

export const defaultAttributes = {
  backdropBlur: 0,
  backdropEdgeSoftness: 0,
  ...SHARED_DEFAULT_ATTRIBUTES,
  backgroundColor: defaultBackgroundColor,
};

export const clearableAttributes = {
  backdropBlur: 0,
  backdropEdgeSoftness: 0,
  ...SHARED_DEFAULT_CLEARABLE_ATTRIBUTES,
  backgroundColor: defaultBackgroundColor,
};

export const hasDownloadMenu = false;

export const hasDuplicateMenu = true;

export const hasEditMode = false;

export const hasEditModeIfLocked = false;

export const hasEditModeMoveable = false;

export const isMedia = false;

export const canFlip = true;

export const isMaskable = true;

export const resizeRules = {
  vertical: true,
  horizontal: true,
  diagonal: true,
  minWidth: 20,
  minHeight: 20,
};

export const panels = [
  PanelTypes.BACKGROUND_BLUR,
  PanelTypes.COLOR_PRESETS,
  PanelTypes.ELEMENT_ALIGNMENT,
  PanelTypes.SIZE_POSITION,
  PanelTypes.BORDER,
  PanelTypes.LAYER_STYLE,
  PanelTypes.LINK,
  PanelTypes.SHAPE_STYLE,
  PanelTypes.BORDER_RADIUS,
  PanelTypes.ANIMATION,
];
